import React from 'react'
import { Row, Col } from 'reactstrap'
import { css } from 'aphrodite'
import PlainValue from 'slate-plain-serializer'

import style from './style'
import FileSystem from './partials/FileSystem'
import CodeEditor from './partials/CodeEditor'

import styleB from '../style'
import uStrings from '../../../utils/strings.js'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

@inject('Auth', 'Motd', 'Template')
@observer
export class MotdSettings extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: PlainValue.deserialize(``)
    }
  }

  componentWillMount () {
    const query = uStrings.parseQueryParams(this.props.location.search)
    if (query.file) {
      this.onFileSelect(query.file)
    }

    this.props.Template.getFileList()
  }

  onCodeChange (change) {
    this.setState({
      ...this.state,
      value: change.value
    })
  }

  onFileSelect (path) {
    this.props.Template.getFileContent(path).then(content =>
      this.setState({ ...this.state, value: PlainValue.deserialize(content) })
    )
  }

  onRenderClick () {
    this.props.Motd.renderAll()
  }

  onSaveClick () {
    const query = uStrings.parseQueryParams(this.props.location.search)

    this.props.Template.putFile(
      query.file,
      PlainValue.serialize(this.state.value)
    )
  }

  render () {
    const query = uStrings.parseQueryParams(this.props.location.search)
    return [
      <Row key={0}>
        <Col xs='12' lg='3' />
        <Col>
          <Row>
            <Col xs='12' lg='6'>
              <h2 className={css(styleB.headers.h2)}>Motd Editor</h2>
            </Col>
            <Col>
              <Row>
                <Col>
                  <span
                    className={css(styleB.buttons.button, styleB.buttons.red)}
                    onClick={this.onRenderClick.bind(this)}
                  >
                    Re-render
                  </span>
                </Col>
                <Col>
                  <span
                    className={css(styleB.buttons.button, styleB.buttons.red)}
                    onClick={this.onSaveClick.bind(this)}
                  >
                    Save File
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>,
      <Row key={1} style={{ height: `calc(100% - 70px)`, maxHeight: `100vh` }}>
        <Col xs='12' lg='3' className={css(style.gui.sbg)}>
          <FileSystem
            currentPath={query.file}
            onFileSelect={this.onFileSelect.bind(this)}
            fileList={this.props.Template.files.toJS()}
          />
        </Col>
        <Col
          style={{ overflowY: `scroll`, height: `100%` }}
          className={css(style.gui.cbg)}
        >
          <CodeEditor
            value={this.state.value}
            codeClassName={css(style.gui.cfont)}
            editorClassName={css(style.gui.cfont)}
            onChange={this.onCodeChange.bind(this)}
          />
        </Col>
      </Row>
    ]
  }
}

export default MotdSettings



// WEBPACK FOOTER //
// ./src/components/Settings/Motd/index.js